import React, { useState } from "react";
import axios from "axios";
import Context from "./index";
import Widget from "../../Helpers/Widget";
import API from "../../ApiService/ApiService";

const TPCouponProvider = (props) => {
  const api = new API();
  const [tpCouponList, setTpcouponList] = useState([]);
  const [tpCouponListLoader, setTpcouponListLoader] = useState(false);
  const [tpCouponListFilter, setTpcouponListFilter] = useState({
    page: 1,
    page_size: 10,
  });
  const [tpCouponDeleteLoader,setTpCouponDeleteLoader] = useState(false);
  const [tpCouponAddLoader,setTpCouponAddLoader] = useState(false);
  const [tpCouponEditLoader,setTpCouponEditLoader] = useState(false);
  async function fetchTpcouponList() {
    setTpcouponListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" && (
      await api.getAll("tp_coupon/list", { ...tpCouponListFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setTpcouponList(res?.data?.data);
        } else {
          setTpcouponList([]);
        }
        setTpcouponListLoader(false);
      })
    )
  }
  async function deleteTpcoupon(id,callback=null) {
    setTpCouponDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" && (
      await api.remove("tp_coupon/deletecoupon", id, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success",res?.data?.message);
          callback && callback();
        }
        setTpCouponDeleteLoader(false);
      })
    )
  }
  
  async function addTPCoupon(data) {
    setTpCouponAddLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.create("tp_coupon/addcoupon", data, (err, res) => {    
      if(err) {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setTpCouponAddLoader(false);
    });
    return result;

  }

  const editTpCoupons = async (data,id) => {
    setTpCouponEditLoader(true);
    const result =
      localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("tp_coupon/updatecoupon",id, data, (err, res) => {
        if (err) {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setTpCouponEditLoader(false);
      }));
    return result;
  };
  return (
    <Context.Provider
      value={{
        ...props,
        fetchTpcouponList,
        tpCouponList, setTpcouponList,
        tpCouponListLoader, setTpcouponListLoader,
        tpCouponListFilter, setTpcouponListFilter,
        deleteTpcoupon,
        tpCouponDeleteLoader,setTpCouponDeleteLoader,
        addTPCoupon,
        tpCouponAddLoader,setTpCouponAddLoader,
        editTpCoupons,
        tpCouponEditLoader,setTpCouponEditLoader,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default TPCouponProvider;
